import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseRepository } from '../../Common/Data/base.repository';
import { Observable } from 'rxjs';

@Injectable()
export class ReturnFormRevisionRepository extends BaseRepository {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    getByAssociatedWithReturns(filingBatchId: number, returnIds: number[]): Observable<Compliance.ReturnFormRevisionModel[]> {
        return this.httpPost(`/api/returnFormRevision/filingBatch/${filingBatchId}/associated`, returnIds);
    }

    getByNotAssociatedWithReturns(filingBatchId: number, returnIds: number[]): Observable<Compliance.ReturnFormRevisionModel[]> {
        return this.httpPost(`/api/returnFormRevision/filingBatch/${filingBatchId}/notAssociated`, returnIds);
    }

    update(filingBatchId: number, models: Compliance.ReturnFormRevisionModel[]): Observable<void> {
        return this.httpPut(`/api/returnFormRevision/filingBatch/${filingBatchId}`, models);
    }

    setReturnFormAsPrimary(filingBatchId: number, model: Compliance.ReturnFormRevisionSetPrimaryModel): Observable<void> {
        return this.httpPut(`/api/returnFormRevision/filingBatch/${filingBatchId}/setPrimary`, model);
    }
}
